// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"a0161e07","920":"17f4285e"}[chunkId] + ".chunk.css";
};